import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import { constants } from 'cng-web-lib'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  const errMsgNumeric = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_NUMERIC
  )

  const errMsgMaxLength = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )

  const regexNumeric = '^[0-9]*$'

  return Yup.object({
    billNo: Yup.string().nullable(),
    parentBillNo: Yup.string().nullable(),
    goodsItemNumber: Yup.string().nullable().max(6, errMsgMaxLength + " 6"),
    containerNumber: Yup.string().nullable().max(17, errMsgMaxLength + " 17"),
    packageQuantity: Yup.string().nullable().matches(regexNumeric, errMsgNumeric).max(8, errMsgMaxLength + " 8"),
  })
}

export default makeValidationSchema
